// API Base URL configuration
// This should be set via REACT_APP_API_URL environment variable
// Default fallback is for development only - update for your environment
export const API_BASE_URL = process.env.REACT_APP_API_URL || (() => {
  console.warn('⚠️ REACT_APP_API_URL not set! Using external server fallback.');
  return 'http://34.84.117.250:3001/api';
})();

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  PAYMENTS: '/payments',
  SUBSCRIPTIONS: '/subscriptions',
  CUSTOMERS: '/customers',
  SETTINGS: '/settings',
  API_KEYS: '/api-keys',
  DEBUG: '/debug',
} as const;

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PENDING_CARD_REGISTRATION: 'pending_card_registration',
  CARD_REGISTERED: 'card_registered',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
  REFUNDED: 'refunded',
  RETRY_PENDING: 'retry_pending',
} as const;

export const SUBSCRIPTION_STATUS = {
  PENDING_CARD_REGISTRATION: 'pending_card_registration',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELLED: 'cancelled',
  PAUSED: 'paused',
} as const;

export const CURRENCY = {
  JPY: 'JPY',
} as const;

export const ROLES = {
  ADMIN: 'admin',
  OPERATOR: 'operator',
} as const;